module.exports = __webpack_public_path__ + "media/assets/fonts/Helvetica-Bold-ed57aca7292971d8548c4554f08c0255.ttf";